// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"formLabel__yyG1Y"};